import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { PortableText } from "@portabletext/react";
import { sanityClient } from "../../sanityClient";
import { sanityPortableTextComponents } from "../components/sanityPortableTextComponents";

const HeroBanner = styled("div")(({ theme }) => ({
  backgroundColor: "#FAE2CF",
  borderBottomLeftRadius: "24px",
  [theme.breakpoints.up(768)]: {
    borderBottomLeftRadius: "50px",
  },
}));

const CategoryTitle = styled("div")(({ theme }) => ({
  color: "#000 !important",
  fontSize: "32px !important",
  lineHeight: "1.2 !important",
  whiteSpace: "normal !important",
  fontFamily: "Helvetica Bold, sans-serif !important",
  fontWeight: "bold !important",
  margin: "0 0 1rem 0 !important",
  display: "block !important",
  textTransform: "none !important",
  [theme.breakpoints.up(768)]: {
    fontSize: "65px !important",
  },
  "&&&": {
    fontSize: "32px !important",
    [theme.breakpoints.up(768)]: {
      fontSize: "65px !important",
    },
  },
}));

const PriceListText = ({ priceList }) => {
  return (
    <div className="container-lg">
      <div className="mb-3">
        <h2>{priceList.title}</h2>
      </div>
      {priceList?.body && (
        <PortableText
          value={priceList.body}
          components={sanityPortableTextComponents}
        />
      )}
    </div>
  );
};

const PriceList = () => {
  const [priceList, setPriceList] = useState(null);

  const getPriceList = async () => {
    const query = `*[_type == "priceList"] | order(sort asc) {
      _id,
      title,
      body
    }`;
    const priceListData = await sanityClient.fetch(query);
    if (priceListData?.length > 0) {
      setPriceList(priceListData[0]);
    } else {
      setPriceList(null);
    }
  };

  useEffect(() => {
    getPriceList();
  }, []);

  return (
    <>
      <section className="my-4 my-md-5 px-3">
        <HeroBanner className="container-lg px-0">
          <div className="row g-0">
            <div className="col-md-6 offset-md-1 px-3">
              <div className="py-4 py-md-5">
                <CategoryTitle className="mb-3">Price List</CategoryTitle>
                <p>
                  View Mockee pricing and related commercial information.
                  <br />
                </p>
              </div>
            </div>
            <div className="col-md-5 px-0">
              <div
                className="h-100 d-flex justify-content-end"
                style={{ paddingRight: "30px" }}
              >
                <img
                  src="/assets/images/ToS.svg"
                  alt="Price List"
                  className="img-fluid h-100 mb-hidden object-fit-cover"
                  style={{
                    borderTopLeftRadius: "60px",
                    width: "45%",
                    objectFit: "contain",
                    objectPosition: "right center",
                    transform: "scaleX(-1)",
                  }}
                />
              </div>
            </div>
          </div>
        </HeroBanner>
      </section>
      <section className="terms-use py-4 py-md-5">
        {priceList && <PriceListText priceList={priceList} />}
      </section>
    </>
  );
};

export default PriceList;
